export const siteURL = 'https://wordpress.openweb.com'; export const spotID = 'sp_3VxIkgJh'; 
